<template>
  <a-row
    type="flex"
    justify="center"
    align="middle"
    style="min-height: 100dvh"
    class="ml-3 mr-3"
  >
    <a-col :xs="24" :md="14" :lg="10">
      <div style="margin-top: 16px">
        <a-steps direction="horizontal">
          <a-step
            v-for="(step, stepIndex) in steps"
            :key="stepIndex"
            :title="step.title"
          />
        </a-steps>
      </div>
      <a-typography-title :level="4" style="margin-top: 16px">
        Ingresa tus cargas
      </a-typography-title>
      <a-typography-paragraph>
        Ingresa los datos de cada una de tus cargas.
      </a-typography-paragraph>
      <a-form layout="vertical" ref="formRef" :model="state">
        <a-row
          v-if="state.dependentsLoading"
          type="flex"
          justify="center"
          align="middle"
        >
          <a-spin />
        </a-row>
        <a-empty
          v-if="!state.dependentsLoading && state.dependents.length === 0"
          description="No has agregado tus cargas"
        />
        <template
          v-for="(dependent, dependentIndex) in state.dependents"
          :key="dependentIndex"
        >
          <a-row type="flex" justify="space-between" align="middle">
            <a-col>
              <a-typography-title :level="5" style="margin: 0">
                Carga {{ dependentIndex + 1 }}
              </a-typography-title>
            </a-col>
            <a-col>
              <a-button
                danger
                size="small"
                @click="() => handleDeleteDependent(dependentIndex)"
              >
                Eliminar
              </a-button>
            </a-col>
          </a-row>
          <a-row type="flex" :gutter="16" style="margin-top: 16px">
            <a-col :xs="24" :md="12">
              <a-form-item
                :name="['dependents', dependentIndex, 'rut']"
                label="Rut"
                :rules="[
                  { validator: rutValidator },
                  { required: true, message: 'El rut es obligatorio.' }
                ]"
              >
                <InputRut v-model="dependent.rut" />
              </a-form-item>
            </a-col>
            <a-col :xs="24" :md="12">
              <a-form-item
                :name="['dependents', dependentIndex, 'dateOfBirth']"
                label="Fecha de nacimiento"
                :rules="{
                  required: true,
                  message: 'La fecha de nacimiento es obligatoria.'
                }"
              >
                <a-date-picker
                  style="width: 100%"
                  format="DD-MM-YYYY"
                  v-model:value="dependent.dateOfBirth"
                />
              </a-form-item>
            </a-col>
          </a-row>
          <a-row type="flex" :gutter="16">
            <a-col :xs="24" :md="12">
              <a-form-item
                :name="['dependents', dependentIndex, 'firstName']"
                label="Primer nombre"
                :rules="{
                  required: true,
                  message: 'El primer nombre es obligatorio.'
                }"
              >
                <InputText v-model="dependent.firstName" />
              </a-form-item>
            </a-col>
            <a-col :xs="24" :md="12">
              <a-form-item
                :name="['dependents', dependentIndex, 'secondName']"
                label="Segundo nombre"
              >
                <InputText v-model="dependent.secondName" />
              </a-form-item>
            </a-col>
          </a-row>
          <a-row type="flex" :gutter="16">
            <a-col :xs="24" :md="12">
              <a-form-item
                :name="['dependents', dependentIndex, 'firstSurname']"
                label="Apellido paterno"
                :rules="{
                  required: true,
                  message: 'El primer apellido es obligatorio.'
                }"
              >
                <InputText v-model="dependent.firstSurname" />
              </a-form-item>
            </a-col>
            <a-col :xs="24" :md="12">
              <a-form-item
                :name="['dependents', dependentIndex, 'secondSurname']"
                label="Apellido materno"
              >
                <InputText v-model="dependent.secondSurname" />
              </a-form-item>
            </a-col>
            <a-col :xs="24" :md="12">
              <a-form-item
                :name="['dependents', dependentIndex, 'relationship']"
                label="Relación"
                :rules="{
                  required: true,
                  message: 'La relación es obligatoria.'
                }"
              >
                <SelectOrdered
                  v-model="dependent.relationship"
                  :options="relationOptions"
                  placeholder="Ingrese relación"
                />
              </a-form-item>
            </a-col>
            <a-col :xs="24" :md="12">
              <a-form-item
                :name="['dependents', dependentIndex, 'gender']"
                label="Sexo designado al nacer"
                :rules="{
                  required: true,
                  message: 'El sexo designado al nacer es obligatorio.'
                }"
              >
                <SelectOrdered
                  v-model="dependent.gender"
                  :options="genderOptions"
                  placeholder="Seleccione una opción"
                />
              </a-form-item>
            </a-col>
          </a-row>
        </template>
      </a-form>
      <div
        v-if="!state.dependentsLoading"
        style="display: flex; flex-direction: column"
      >
        <a-button style="align-self: flex-end" @click="handleAddDependent">
          Agregar carga
        </a-button>
      </div>
      <a-row
        style="margin-top: 18px; margin-bottom: 18px"
        :gutter="16"
        type="flex"
        justify="space-between"
      >
        <a-col :span="8">
          <a-button
            :loading="state.dependentsLoading || state.putLoading"
            block
            size="large"
          >
            <router-link
              :to="{
                name: 'DependentsIncorporationForm',
                params: { token: route.params.token }
              }"
            >
              Atrás
            </router-link>
          </a-button>
        </a-col>
        <a-col :span="8">
          <a-button
            :loading="state.dependentsLoading || state.putLoading"
            block
            type="primary"
            size="large"
            @click="submitForm"
          >
            Siguiente
          </a-button>
        </a-col>
      </a-row>
    </a-col>
  </a-row>
</template>

<script setup>
import { useRoute, useRouter } from 'vue-router';
import { reactive, ref, onMounted, h } from 'vue';
import { useStore } from 'vuex';
import moment from 'moment';
import rutHelper from '@/utils/Ruts';
import { genderOptions } from '@/utils/gender';
import {
  FETCH_DEPENDENTS_INCORPORATION_FORM_EMPLOYEE,
  FETCH_DEPENDENTS_INCORPORATION_FORM,
  FETCH_TICKET_DEPENDENT_INCORPORATIONS,
  POST_TICKET_DEPENDENT_INCORPORATION,
  PATCH_TICKET_DEPENDENT_INCORPORATION,
  DELETE_TICKET_DEPENDENT_INCORPORATION
} from '@/store/types';
import notification from '@/utils/notifications';
import InputRut from '@/bewell-components/form-controls/input-rut.vue';
import InputText from '@/bewell-components/form-controls/input-text.vue';
import SelectOrdered from '@/bewell-components/form-controls/select-ordered.vue';
import { Modal } from 'ant-design-vue';

const route = useRoute();
const router = useRouter();
const store = useStore();

const steps = [
  {
    title: 'Ingresa tus cargas'
  },
  {
    title: 'Carga tus documentos'
  }
];

const formRef = ref();
const state = reactive({
  ticketId: null,
  persistedDependents: [],
  employee: {},
  employeeLoading: true,
  dependents: [],
  loading: true,
  dependentsLoading: true,
  putLoading: false
});

const handleAddDependent = () => {
  state.dependents.push({
    rut: '',
    firstName: '',
    secondName: '',
    firstSurname: '',
    secondSurname: '',
    dateOfBirth: null,
    relationship: null,
    gender: null
  });
};

const handleDeleteDependent = (dependentIndex) => {
  state.dependents = state.dependents.filter(
    (_, idx) => idx !== dependentIndex
  );
};

const getTicketIdFromToken = (token) => {
  try {
    const decodedToken = JSON.parse(atob(token.split('.')[1]));
    return decodedToken?.tid || null;
  } catch (error) {
    return null;
  }
};

const normalizeText = (value) =>
  typeof value === 'string' ? value.trim() : '';

const mapDependentFromApi = (dependent) => ({
  id: dependent.id,
  rut: rutHelper.formatRut(dependent.rut),
  firstName: dependent.firstName || '',
  secondName: dependent.secondName || '',
  firstSurname: dependent.firstSurname || '',
  secondSurname: dependent.secondSurname || '',
  dateOfBirth: dependent.dateOfBirth ? moment(dependent.dateOfBirth) : null,
  relationship: dependent.relationship || null,
  gender: dependent.gender || null
});

const buildDependentPayload = (dependent) => ({
  rut: rutHelper.normalizeRut(dependent.rut),
  firstName: normalizeText(dependent.firstName),
  secondName: normalizeText(dependent.secondName),
  firstSurname: normalizeText(dependent.firstSurname),
  secondSurname: normalizeText(dependent.secondSurname),
  dateOfBirth: dependent.dateOfBirth
    ? moment(dependent.dateOfBirth).format('YYYY-MM-DD')
    : null,
  relationship: dependent.relationship,
  gender: dependent.gender
});

const normalizePersistedDependent = (dependent) => ({
  id: dependent.id,
  ...buildDependentPayload(dependent)
});

const sameDependentPayload = (previousDependent, nextPayload) =>
  previousDependent.rut === nextPayload.rut &&
  previousDependent.firstName === nextPayload.firstName &&
  previousDependent.secondName === nextPayload.secondName &&
  previousDependent.firstSurname === nextPayload.firstSurname &&
  previousDependent.secondSurname === nextPayload.secondSurname &&
  previousDependent.dateOfBirth === nextPayload.dateOfBirth &&
  previousDependent.relationship === nextPayload.relationship &&
  previousDependent.gender === nextPayload.gender;

const getApiErrorMessage = (error, fallbackMessage) => {
  const status = error?.response?.status;
  const message = error?.response?.data?.message;
  if (
    (status === 400 || status === 401 || status === 404 || status === 409) &&
    message
  ) {
    return message;
  }
  return fallbackMessage;
};

const refreshDependents = async () => {
  const dependents = await store.dispatch(
    FETCH_TICKET_DEPENDENT_INCORPORATIONS,
    {
      ticketId: state.ticketId,
      token: route.params.token
    }
  );
  state.dependents = dependents.map(mapDependentFromApi);
  state.persistedDependents = dependents.map(normalizePersistedDependent);
};

const syncDependents = async () => {
  const persistedById = new Map(
    state.persistedDependents.map((dependent) => [dependent.id, dependent])
  );
  const nextIds = new Set(
    state.dependents
      .filter((dependent) => dependent.id)
      .map((dependent) => dependent.id)
  );

  const dependentsToDelete = state.persistedDependents.filter(
    (dependent) => !nextIds.has(dependent.id)
  );

  for (const dependent of dependentsToDelete) {
    await store.dispatch(DELETE_TICKET_DEPENDENT_INCORPORATION, {
      ticketId: state.ticketId,
      dependentIncorporationId: dependent.id,
      token: route.params.token
    });
  }

  for (const dependent of state.dependents) {
    const payload = buildDependentPayload(dependent);
    if (dependent.id) {
      const previousDependent = persistedById.get(dependent.id);
      if (
        previousDependent &&
        !sameDependentPayload(previousDependent, payload)
      ) {
        await store.dispatch(PATCH_TICKET_DEPENDENT_INCORPORATION, {
          ticketId: state.ticketId,
          dependentIncorporationId: dependent.id,
          payload,
          token: route.params.token
        });
      }
      continue;
    }

    await store.dispatch(POST_TICKET_DEPENDENT_INCORPORATION, {
      ticketId: state.ticketId,
      payload,
      token: route.params.token
    });
  }

  await refreshDependents();
};

const submitForm = async () => {
  const isValid = await formRef.value.validate();
  if (!isValid) return;
  if (state.dependents.length == 0) {
    notification('error', 'Error', 'Debe incorporar al menos una carga.');
    return;
  }

  Modal.confirm({
    title: 'Confirmar envío',
    content: h('div', {
      innerHTML: `
      ¿Está seguro de que quiere incorporar <strong>${state.dependents.length} 
      carga${state.dependents.length > 1 ? 's' : ''}</strong>? 
      Puede volver y agregar más cargas haciendo click en "Cancelar".`
    }),
    okText: 'Sí, continuar',
    cancelText: 'Cancelar',
    onOk: async () => {
      try {
        state.putLoading = true;
        await syncDependents();
        router.push({
          name: 'DependentsIncorporationFormStep2',
          params: { token: route.params.token }
        });
      } catch (error) {
        notification(
          'error',
          'Error',
          getApiErrorMessage(
            error,
            'Ha ocurrido un error al guardar las cargas'
          )
        );
      } finally {
        state.putLoading = false;
      }
    }
  });
};

const rutValidator = (_, value) => {
  const isValid = rutHelper.validateRut(value);
  if (value && !isValid) return Promise.reject('RUT inválido.');

  const employeeFormattedRut = rutHelper.formatRut(state.employee.rut);

  if (employeeFormattedRut === rutHelper.formatRut(value))
    return Promise.reject('Debe ser un RUT distinto al RUT del titular.');

  if (state.dependents.filter((d) => d.rut === value).length > 1)
    return Promise.reject('RUT repetido.');

  return Promise.resolve();
};

const relationOptions = [
  {
    label: 'Cónyuge',
    value: 'SPOUSE'
  },
  {
    label: 'Conviviente',
    value: 'COHABITANT'
  },
  {
    label: 'Hijo(a)',
    value: 'CHILD'
  },
  {
    label: 'Padre/Madre',
    value: 'PARENT'
  },
  {
    label: 'Nieto(a)',
    value: 'GRANDCHILD'
  },
  {
    label: 'Hermano(a)',
    value: 'SIBLING'
  }
];

onMounted(async () => {
  try {
    const form = await store.dispatch(
      FETCH_DEPENDENTS_INCORPORATION_FORM,
      route.params.token
    );
    state.ticketId =
      getTicketIdFromToken(route.params.token) || form?.ticketId || form?.id;
    if (form.state !== 'Creado') {
      router.push({ name: 'DependentsIncorporationFormError' });
    } else if (form.isTokenExpired) {
      router.push({ name: 'DependentsIncorporationFormExpired' });
    }
    state.loading = false;
  } catch (error) {
    if (error?.response?.status === 401) {
      notification(
        'error',
        'Error',
        error?.response?.data?.message ||
          'No tienes permisos para acceder a este ticket con este enlace.'
      );
    }
    router.push({ name: 'DependentsIncorporationFormError' });
  }

  try {
    state.employeeLoading = true;
    const response = await store.dispatch(
      FETCH_DEPENDENTS_INCORPORATION_FORM_EMPLOYEE,
      route.params.token
    );
    state.employee = response.data;
  } catch (error) {
    console.error(error);
    notification(
      'error',
      'Error',
      'Ha ocurrido un error al obtener el titular'
    );
  } finally {
    state.employeeLoading = false;
  }

  try {
    state.dependentsLoading = true;
    if (!state.ticketId) {
      throw new Error('Missing ticket id for dependent incorporation form.');
    }
    await refreshDependents();
  } catch (error) {
    notification(
      'error',
      'Error',
      getApiErrorMessage(error, 'Ha ocurrido un error al obtener las cargas')
    );
  } finally {
    state.dependentsLoading = false;
  }
});
</script>
